import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { HeadingLG, LabelMD, ParagraphSM, TitleSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'

interface TextOverlayProps {
  className: string
}

export const TextOverlay: React.FC<TextOverlayProps> = ({ className }) => {
  const { t } = useTranslate('about')

  return (
    <div className={classNames(className)}>
      <FlexColumn className="gap-8">
        <FlexColumn className="gap-4">
          <TitleSM className="md:photon-title-lg" weight="semibold">
            {t('ourMission', 'Our Mission')}
          </TitleSM>
          <HeadingLG className="md:photon-heading-xl lg:photon-display md:max-w-[356px] lg:max-w-none" weight="bold">
            {t('buildingHomeHeader', `We're building a home for stories that amplify light.`)}
          </HeadingLG>
          <ParagraphSM className="md:photon-paragraph-md lg:photon-paragraph-lg">
            {t(
              'buildingHomeParagraph',
              `We’re building a home for stories that amplify light, which is also what we call our North Star. Angel Studios is proud to be a film studio that emphasizes stories that shed light in the darkness and focus on brightening the world around us.`,
            )}
          </ParagraphSM>
        </FlexColumn>
        <LinkButton className="h-12 md:h-[56px] md:w-1/2 xl:w-1/4" href={paths.about.ourMission} variant="white">
          <LabelMD className="md:photon-label-lg">{t('learnMore', 'Learn More')}</LabelMD>
        </LinkButton>
      </FlexColumn>
    </div>
  )
}
